import { bindable } from 'aurelia-framework';

export class ToggleButton {
    @bindable value: boolean;
    @bindable change: (any) => void;
	@bindable label: string;
    toggleValue() {
        this.value = !this.value;
        this.change({ value: this.value });
    }
}
